// API Configuration
export const API_RETRY_ATTEMPTS = 3;
export const API_RETRY_DELAY_MS = 1000;

// Message Configuration
export const MAX_MESSAGE_LENGTH = 4000;
export const MAX_MESSAGE_HISTORY = 10;

// Time Constants
export const DAYS_IN_MS = 24 * 60 * 60 * 1000;
export const RECENT_CHAT_DAYS = 7;
export const OLDER_CHAT_DAYS = 30;

// Default Sample Prompts (used as fallback)
export const SAMPLE_PROMPTS = [];

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR:
    "Service is currently under maintenance. Please try again later.",
  SEND_MESSAGE_FAILED:
    "Service is currently under maintenance. Please try again later.",
  LOAD_SESSIONS_FAILED:
    "Service is currently under maintenance. Please try again later.",
  DELETE_SESSION_FAILED:
    "Service is currently under maintenance. Please try again later.",
  RENAME_SESSION_FAILED:
    "Service is currently under maintenance. Please try again later.",
  SUBMIT_FEEDBACK_FAILED:
    "Service is currently under maintenance. Please try again later.",
  ENHANCE_PROMPT_FAILED:
    "Service is currently under maintenance. Please try again later.",
  LOAD_PROMPTS_FAILED: "Failed to load prompts.",
  MESSAGE_TOO_LONG: `Message is too long. Maximum length is ${MAX_MESSAGE_LENGTH} characters.`,
  MESSAGE_EMPTY: "Please enter a message.",
  SESSION_LOAD_FAILED:
    "Service is currently under maintenance. Please try again later.",
};

// Success Messages
export const SUCCESS_MESSAGES = {
  MESSAGE_SENT: "Message sent successfully",
  SESSION_DELETED: "Session deleted successfully",
  SESSION_RENAMED: "Session renamed successfully",
  FEEDBACK_SUBMITTED: "Thank you for your feedback!",
};
